export default {
  data () {
    return {
      categories: [
        { value: 'CHARGE', name: 'Charge' },
        { value: 'COST', name: 'Cost' }
      ],
      markups: [
        { value: 'LUMPSUM', name: 'Lump sum' },
        { value: 'PERCENT', name: 'Percentage' }
      ],
      sources: [
        { value: 'COST_SUBTOTAL', name: 'Cost Subtotal' },
        { value: 'LUMPSUM', name: 'Lump sum' }
      ],
      subtotals: ['OS', 'FR', 'DS', 'IN', 'ST', 'MI', 'DI', 'ALL'],
      totalTypes: [
        { value: 'SOURCE', name: 'Source' },
        { value: 'MARKUP', name: 'Markup' },
        { value: 'SOURCE_AND_MARKUP', name: 'Source and Markup' }
      ]
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/admin/components/FinancialProfile/Mixin.js